/* global theme*/
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Alarm from '@material-ui/icons/Alarm';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailOutline from '@material-ui/icons/MailOutline';
import Play from '@material-ui/icons/ArrowRightRounded';
import Close from '@material-ui/icons/Close';
import Utils from '../Utils/Utils';


export class ButtonFiche extends React.Component {
  constructor(props) {
    super(props);
    const paddingX = 10;
    const paddingY = 5;
    this.state = {};
    this.styles = {
      button: {
        padding: `${paddingY}px ${paddingX}px`,
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        border: '2px solid ' + props.background,
        boxShadow: 'none',
        outline: 'none',
        boxSizing: 'border-box',
        textTransform: 'uppercase',
        position: 'relative',
        color: props.background,
        borderRadius: '5px',
        cursor: 'pointer',
        backgroundColor: 'transparent',		
        overflow: 'hidden',
        fontWeight: '600',
        fontSize: '9px',
        lineHeight: '1',
      },
      text: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginTop: '2px',
      },
      icon: {
        display: 'block',
        marginLeft: '5px',
      }
    };
  }
  

  render() {
    const { children } = this.props;
    return (
      <button className="button-fiche" style={this.styles.button} >
        <span className="button-fiche__text" style={this.styles.text}>{ children }</span>
        <span className="button-fiche__icon" style={this.styles.icon}>
          <span className="material-symbols-outlined" style={{ fontSize: '200%' }}>
            timer
          </span>
        </span>
      </button>
    );
  }
}


export default class Speaker extends React.Component {
  
  colors = {
    text: window.theme.palette.background.txt || '#333333',
    background: window.theme.palette.background.paper,
    primary: window.theme.palette.primary.main,
    secondary: window.theme.palette.secondary.main,
  };
  
  state = {
    show: false,
    chapters: []
  }
  
  constructor(props) {
    super(props);
    
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.getContainer = this.getContainer.bind(this);
    this.isTouch = false
  }

  getContainer(ref) {
    this.container = ref;
  }
  
  handleClose = () => {
    this.setState({
      show: false
    })
  }
  
  componentDidMount() {
    window.sdk.on('showSpeaker', async (data) => {
      let speakerData = await window.sdk.getSpeaker(data.id, data.title);
      console.log(speakerData);
      let chapters;
      if(data.live)
        chapters = window.sdk.getLiveChaptersBySpeaker(data.id);
      else
        chapters = window.sdk.getChaptersBySpeaker(data.title);
      
      this.setState({
        chapters,
        show: true,
        title: data.title,
        description: data.description,
        speakerData: speakerData.data,
        photo: speakerData.photo,
        live: data.live
      });
      
      //document.getElementById('speakerWindow').style.left = data.x - document.getElementById('speakerWindow').offsetWidth - 40;
      //document.getElementById('speakerWindow').style.top = (document.body.offsetHeight / 2) - (document.getElementById('speakerWindow').offsetHeight / 2);
    })
    
    window.sdk.on('hideSpeakerPopup', async () => {
      //this.handleClose()
    });
    
    
    document.addEventListener('touchend', this.handleClickOutside, true)
    document.addEventListener('mousedown', this.handleClickOutside, true)
  }

  componentWillUnmount() {
    document.removeEventListener('touchend', this.handleClickOutside, true)
    document.removeEventListener('mousedown', this.handleClickOutside, true)
  }

  handleClickOutside(e) {
    if (e.type === 'touchend') this.isTouch = true;
    if (e.type === 'click' && this.isTouch) return;
    let el = this.container;
    if (el) {
      el = el.querySelector('.speaker_modal');
    }
    if (el && !el.contains(e.target)) {
      this.handleClose();
    }
  }
  
  entered = () => {
    if(this.timeout)  
      clearTimeout(this.timeout)
    window.entered = true;
  }
  
  outed = () => {
    return;
    if(this.timeout)  
      clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.handleClose()
    }, 2000)
  }
  
  outed2 = () => {
   
      this.handleClose()
  }

	bbcodeToHtml(text) {
		// Remplacer les \r\n par <br/>
		text = text.replace(/\r\n/g, "<br/>");
	
		// Remplacer les [b] par <b>
		text = text.replace(/\[b\]/g, "<b>");
	
		// Remplacer les [/b] par </b>
		text = text.replace(/\[\/b\]/g, "</b>");
	
		// Remplacer les [i] par <i>
		text = text.replace(/\[i\]/g, "<i>");
	
		// Remplacer les [/i] par </i>
		text = text.replace(/\[\/i\]/g, "</i>");
		
		// Remplacer les [i] par <i>
		text = text.replace(/\[u\]/g, "<u>");
	
		// Remplacer les [/i] par </i>
		text = text.replace(/\[\/u\]/g, "</u>");
	
		return text;
	}
  
  
  render() {
    
    let css = '.primary { color: ' + this.colors.secondary +'; margin-top: -14px ;ont-size: 16px;font-weight:600; } } ';
    
    if(!this.state.show)
      return null;
      
    // console.log('this.state.chapters', this.state.chapters)
    
    return (
      <div className="speaker_dialog" ref={this.getContainer}>
        <style dangerouslySetInnerHTML={{__html: css}} />
        <Card className="speaker_modal">
          <div className="close_container" onClick={(e) => { this.handleClose() }}>
            <Close style={{ color: this.colors.text }} /> 
          </div>
          
          <CardHeader  style={{ flexDirection: 'row-reverse', margin: '0' }}
            avatar={
              <Avatar  className={ 'avatar_speaker' } style={{ width: '60px', height: '60px', marginRight:'-16px', border: "3px solid " + this.colors.primary }} aria-label="Recipe">
                { !this.state.photo &&
                  <AccountCircle />
                }
                { this.state.photo &&
                  <img  src={ this.state.photo } />
                }
              </Avatar>
            }
            title={ 
              <React.Fragment>
                <b style={{ color: this.colors.primary, fontSize: '1.125rem' }}>{this.state.title}</b>
                <div className={'social_icon'}>
                  { this.state.speakerData && this.state.speakerData.web_site != "" &&
                    <div className={'social_icon_item'}>
                      <img src="/public/link.png" onClick={ (e) => { window.open(this.state.speakerData.web_site) } } />
                    </div>
                  }
                  { this.state.speakerData && this.state.speakerData.twitter  != "" &&
                    <div className={'social_icon_item'}>
                      <img src="/public/twitter.png" onClick={ (e) => { window.open(this.state.speakerData.twitter) } } />
                    </div>
                  }
                  { this.state.speakerData && this.state.speakerData.facebook  != "" &&
                    <div className={'social_icon_item'}>
                      <img src="/public/facebook.png" onClick={ (e) => { window.open(this.state.speakerData.facebook) } } />
                    </div>
                  }
                  { this.state.speakerData && this.state.speakerData.email != "" &&
                    <div className={'social_icon_item'}>
                      <img src="/public/email.png" onClick={ (e) => { window.open('mailto:' + this.state.speakerData.email) } }  />
                    </div>
                  }
                </div>
              </React.Fragment>
            }
            subheader={
              <React.Fragment>
                <span style={{ color: this.colors.text }}>{ this.state.speakerData.organization }</span> <br /> 
                <span style={{ color: this.colors.text }}>{(this.state.speakerData.function ? this.state.speakerData.function:'') }</span>
              </React.Fragment>
            }
          />

          { this.state.speakerData.intro_text &&
            <Typography style={{ padding: '0px 15px', whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{__html: this.bbcodeToHtml(this.state.speakerData.intro_text)}}>
            </Typography>
          }

          <CardContent>
            <div className="other-interventions">
              <Typography className="liste-intervention-title">
                <span style={{ color: this.colors.primary }}>Autre(s) intervention(s) lors de la séance</span>
              </Typography>
              <div className="line" style={{ backgroundColor: this.colors.primary }}></div>
            </div>
            
            <ul>
              {this.state.chapters.map((chapter, index) => {
                return (
                  <ListItem key={ index } onClick={ () => { window.sdk.player().seek(chapter.start_second); this.handleClose() }} style={{ cursor: 'pointer', padding:'5px 0px', alignItems: 'flex-start'}}>
                    <ListItemText
                      style={{ padding: 0 }}
                      disableTypography
                      primary={ 
                        <Typography className="search_item_row"> 
                          <span style={{color: this.colors.text}}>
                            { (window.sdk.getChapter(chapter.odjIndex)) && 
                                  window.sdk.getChapter(chapter.odjIndex).title 
                            }
                            { !(window.sdk.getChapter(chapter.odjIndex)) && 
                                  chapter.title 
                            }
                          </span>
                          <span className="search_item_btn">
                            <span className="search_item">
                              <ButtonFiche background={ this.colors.primary }>{ window.sdk.getDateFromSecond(chapter.start_second) }</ButtonFiche>
                            </span>
                          </span>
                        </Typography>  
                      }
                    />
                  </ListItem>
                );
              })}
            </ul>
          </CardContent>
        </Card>
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/Player/Speaker.js